export enum Roles {
    ADMIN = 'ADMIN',
    FIDUCIARY = 'FIDUCIARY',
    INVESTOR = 'INVESTOR',
    MEMBER = 'MEMBER',
    USER = 'USER',
    OPERATOR = 'OPERATOR'
}  